module.exports = __webpack_public_path__ + "static/media/arrow_right_mobile.3d690af4.svg";